import { create } from "zustand"

type PendingMessage = {
  text: string
  sourceSessionId: string | null
  sourceSessionTitle: string | null
  messageType: "user" | "assistant"
}

type PendingMessageStore = {
  pendingMessage: PendingMessage | null
  setPendingMessage: (message: PendingMessage) => void
  clearPendingMessage: () => void
}

export const usePendingMessageStore = create<PendingMessageStore>((set) => ({
  pendingMessage: null,
  setPendingMessage: (message) => set({ pendingMessage: message }),
  clearPendingMessage: () => set({ pendingMessage: null }),
}))
